<template>
  <main>
    <div class="info">
      <div>
          <textarea placeholder="为更好的帮助您解决问题，请您描述具体问题！" v-model="opinion.problem"></textarea>
      </div>
          <div class="opinion">
            <van-uploader :after-read="afterRead" preview-size="75px" v-model="addFile.file"/>
      </div>
    </div>
    <div>
    <button class="lol btn btn-green" @click="submit">提交</button>
    </div>
  </main>
</template>

<script>
    import {Toast} from 'vant';
    import API from "../api/index"

    
    export default {
        inject:['reload'],
        name: "opinion",
        data () {
          return {
            opinion: {},
            addFile: {},
    }
  },
  methods: {

    afterRead(file) {
      
      
    },

    mycarBtn() {
        this.$router.push('/my')
            },

    submit() {
      var _this=this;
      this.$http({
                   
      method:'post',
      data:this.opinion,
      url:API.opinion_url,
    }).then(function(resp){
      Toast('提交成功');
      _this.reload();
    }).catch(resp => {
      Toast('提交失败');
    });

      this.$http({
                   
      method:'post',
      data:this.addFile,
      url:API.uploadFile_url,
    }).then(function(resp){
      console.log(resp.data);
    }).catch(resp => {
      console.log('请求失败：'+resp.status+','+resp.statusText);
    });
    },
  }

    }
</script>

<style scoped>
  .info {
    margin: 30px;
    background: #fff;
    box-shadow: 0 0 10px #ccc;
    padding: 0 20px;
  }

  .info div {
    display: flex;
    padding: 10px 10px;
    height: 350px;
    font-size: 30px;
    width: 100%;
  }

  .info div textarea {
      width: 100%;
  }

  .info .opinion {
      padding-bottom: 50px;
  }

/deep/.van-popup {
  height: 300px;
}

/deep/.van-action-sheet__name {
  color: black;
}

/deep/.van-action-sheet__cancel {
  font-size: 28px;
  color: black;
}

/deep/.van-action-sheet__item {
  height: 100px;
}
   .lol {
       margin-top: 200px;
   }
   
</style>



// WEBPACK FOOTER //
// src/pages/opinion.vue